import Cookies from 'js-cookie'

/**
 * Dono do cookie de sessão da NexAtlas. O cookie é de domínio `.nexatlas.com`, ou seja, é compartilhado
 * com o Account e com os outros apps da NexAtlas — um login/logout no Account (ou em outro app) feito em
 * outra aba rotaciona o token por baixo de uma aba aberta do planning-app. Por isso o token nunca deve
 * ser tratado como imutável depois do boot.
 */
export const AUTH_COOKIE_NAME = '_nat'
export const AUTH_COOKIE_DOMAIN = '.nexatlas.com'

export function readAuthCookie(): string | null {
  return Cookies.get(AUTH_COOKIE_NAME) ?? null
}

/**
 * Apaga o cookie de sessão do domínio compartilhado. O `_nat` gravado pelo Account é `Secure`, e o
 * navegador só deixa uma página https apagá-lo: numa página http a remoção é ignorada em silêncio.
 */
export function removeAuthCookie(): void {
  Cookies.remove(AUTH_COOKIE_NAME, { domain: AUTH_COOKIE_DOMAIN })
}
